import React from 'react';
import Logo from '../../assets/logoGesDent.png';
import './gestdent.css';

const Objective = () => {
  return (
    <section id="Objective" className="container">
      {/* ------------------------------- Objective ------------------------------------------ */}
      <h2>Objective</h2>
      <div className="obj">
        <p>&nbsp;&nbsp;&nbsp;&nbsp;The name of our software was carefully considered during the design process. We have named our software "GrinWise," which is a combination of the words "grin" (broad smile) and "wise" (intelligent). The term suggests a thoughtful and intelligent approach to smiles and dental health.
          <br />Our slogan is: "A Smile is a Mission."</p>
        <div className="logo-img">
          <img src={Logo} alt="logo" />
        </div>
      </div>
    </section>
  );
};

export default Objective;
